// extracted by mini-css-extract-plugin
export default {"input":"InputFile_input__L3fXG"};